import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import World from "@/pages/World";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App dark bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<World />} />
          <Route path="/classic" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          classNames: {
            toast: "bg-[#111015] border border-[rgba(244,234,222,0.16)] text-[#F4EADE]",
          },
        }}
      />
    </div>
  );
}

export default App;
